import React from 'react';
import ToggleIcon from './Icons/ToggleIcon';
import { TOGGLE_STATUSES } from '../../constants/toggleStatuses';

const ToggleButton = ({ status, onToggle }) => {
  const isEnabled = status === TOGGLE_STATUSES.ENABLED;

  return (
    <button
      type="button"
      aria-pressed={isEnabled}
      onClick={onToggle}
      className="focus:outline-none"
    >
      <ToggleIcon status={status} />
    </button>
  );
};

export default ToggleButton;
